import $ from "jquery"
import Minpubsub from "minpubsub"
import i18n from "lib/i18n"
import { currentUser } from "lib/currentUser"
import { wrapInUserModel } from "models/user"
import Comments from "models/comments"

/**
 * @param {string} contentSlug
 */
function closeComments(contentSlug) {
  const url = `/editorial/content/${contentSlug}/close_comments`
  return $.ajax({
    url,
    type: "PUT",
    success(data) {
      return Minpubsub.publish("comments:closed", [data.comments_closed_at])
    },
  })
}

/*
 * @param {string} contentSlug
 */
function openComments(contentSlug) {
  const url = `/editorial/content/${contentSlug}/open_comments`
  return $.ajax({
    url,
    type: "PUT",
    success(data) {
      return Minpubsub.publish("comments:opened", [data.comments_closed_at])
    },
  })
}

function updateCommentCount(commentsCount) {
  const commentsCountText =
    commentsCount !== 1
      ? i18n.t("comment.label.comment_plural")
      : i18n.t("comment.label.comment_singular")

  $(".comment-count").html(`${commentsCount} ${commentsCountText}`)
}

/**
 * We will only render the comments section in case of:
 * * Comments are open
 * * Comments are closed but there are comments
 * * Comments are closed, there are no comments but the user is an editor
 */
async function renderCommentSection(contentSlug, contentId, commentsClosedAt) {
  /**
   * Let's verify if we need to render the comments section
   */
  const user = await currentUser().then(wrapInUserModel)
  const comments = new Comments({ content_id: contentId, user })
  await comments.fetch()

  const noComments = comments.get("comment_count") === 0
  const isCommentSectionClosed = new Date(commentsClosedAt) < new Date()

  if (!user.isEditor() && noComments && isCommentSectionClosed) {
    return
  }

  /**
   * In case we do, let's render it:
   */
  const { default: CommentsSectionView } = await import("views/comments_section_view")

  Minpubsub.subscribe("comments:count:updated", updateCommentCount)
  Minpubsub.subscribe("comments:close", () => closeComments(contentSlug))
  Minpubsub.subscribe("comments:open", () => openComments(contentSlug))

  // Comment section
  const commentsSectionView = new CommentsSectionView({
    commentsClosedAt,
    contentSlug,
    content_id: contentId,
  })
  commentsSectionView.$el.appendTo($("#comments-container"))

  updateCommentCount()
}

/**
 *
 * @param {string} contentSlug
 * @param {string} contentId
 * @param {string} commentsClosedAt
 */
export default function initCommentSection({ contentSlug, contentId, commentsClosedAt }) {
  const isCommentDeepLinked = /comment_[0-9]+/.test($(location).attr("hash"))

  if (typeof IntersectionObserver === "undefined" || isCommentDeepLinked) {
    renderCommentSection(contentSlug, contentId, commentsClosedAt)
  } else {
    const commentsIntersectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          renderCommentSection(contentSlug, contentId, commentsClosedAt)
          observer.disconnect()
        }
      })
    })

    const observedCommentsContainer = document.querySelector("#comments-container")

    if (observedCommentsContainer) {
      commentsIntersectionObserver.observe(observedCommentsContainer)
    }
  }
}
